import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import _ from 'lodash'
import axios from 'axios';
import { config } from '../constants/config'

export const fetchVoiceSnippets = createAsyncThunk(
  'voiceSnippets/fetchVoiceSnippets',
  async ({ userId, folderName, fileName, version }) => {
    let query = `${config.GET_API_VOICE_CLONE_SNIPPETS}/${userId}/${folderName}`
    if (fileName && version) query = `${config.GET_API_VOICE_CLONE_SNIPPETS}/${userId}/${folderName}/${fileName}/${version}`
    else if (fileName) query = `${config.GET_API_VOICE_CLONE_SNIPPETS}/${userId}/${folderName}/${fileName}`
    const response = await axios.get(query);
    return response.data;
  }
);

export const deleteVoiceAndTextSnippets = createAsyncThunk(
  'voiceSnippets/deleteVoiceAndTextSnippets',
  async ({ userId, uuid }, { getState, dispatch }) => {

    // manage voice snippet delete
    const voiceSnippetState = getState().user.voiceSnippets.snippets.snippets;
    const targetVoiceSnippet = _.find(voiceSnippetState, x => x.uuid === uuid);
    let s3VoiceUrlEscaped = encodeURIComponent(targetVoiceSnippet.s3Url)

    // console.log('s3VoiceUrlEscaped', s3VoiceUrlEscaped)
    const voiceDelResponse = await axios.delete(`${config.GET_API_VOICE_SNIPPETS}/${userId}/${uuid}/${s3VoiceUrlEscaped}`);

    // manage associated text snippet delete (bound by common uuid values)
    const textSnippetState = getState().user.textSnippets.snippets.snippets;
    let targetTextSnippet = _.find(textSnippetState, x => x.uuid === uuid);
    let s3TextUrlEscaped = encodeURIComponent(targetTextSnippet.s3TextUrl)
    // console.log('s3TextUrlEscaped', s3TextUrlEscaped)

    const textDelResponse = await axios.delete(`${config.GET_API_TEXT_SNIPPETS}/${userId}/${targetTextSnippet.uuid}/${s3TextUrlEscaped}`);

    // return { voiceSnippets: voiceDelResponse.data, textSnippets: textDelResponse.data };
    return { voiceDelResponse: voiceDelResponse.data, textDelResponse: textDelResponse.data }
  }
);



export const deleteVoiceSnippet = createAsyncThunk(
  'voiceSnippets/deleteVoiceSnippet',
  async ({ userId, uuid, s3VoiceUrl }) => {
    let s3VoiceUrlEscaped = encodeURIComponent(s3VoiceUrl)
    const response = await axios.delete(`${config.GET_API_VOICE_SNIPPETS}/${userId}/${uuid}/${s3VoiceUrlEscaped}`);
    return response.data;
  }
);

export const addVoiceSnippet = createAsyncThunk(
  'voiceSnippets/addVoiceSnippet',
  async ({ userId, fileName, variation, s3Url, version, uuid }) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      const instance = axios.create({
        baseURL: config.BASE_URL,  // specify your base URL
        headers: { 'Authorization': `Bearer ${token}` }
      });

      try {
        const response = await instance.post(config.ADD_API_VOICE_META_DATA, { userId, fileName, variation, s3Url, version, uuid });
        return response.data;
      } catch (error) {
        console.error('Error saving voice snippet:', error.response.data);
      }
    }
    else {
      console.error('Error saving voice snippet: Invalid user token');
    }
  }
);

const selectVoiceSnippetsState = state => state.user.voiceSnippets;

export const selectAllVoiceSnippets = createSelector(
  selectVoiceSnippetsState,
  (voiceSnippetsState) => {
    if (voiceSnippetsState.fetchVoicestatus === "succeeded" ||
      voiceSnippetsState.addVoicestatus === "succeeded") {
      try {
        return voiceSnippetsState.snippets.snippets;
      } catch (e) {
        console.error('No snippets', e.message);
        return [];
      }
    }
    else {
      // console.error('Current voiceSnippets.fetchVoicestatus', voiceSnippetsState.fetchVoicestatus);
      return [];
    }
  }
);

const voiceSnippetSlice = createSlice({
  name: 'voiceSnippets',
  initialState: {
    snippets: [],
    status: 'idle',
    addVoicestatus: 'idle',
    deleteVoicestatus: 'idle',
    fetchVoicestatus: 'idle',
    deleteVoiceAndTextStatus: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVoiceSnippets.pending, (state) => {
        state.fetchVoicestatus = 'loading';
        // console.log('fetchVoiceSnippets  pending', 'loading')
      })
      .addCase(fetchVoiceSnippets.fulfilled, (state, action) => {
        state.fetchVoicestatus = 'succeeded';
        state.snippets = action.payload;
      })
      .addCase(fetchVoiceSnippets.rejected, (state, action) => {
        state.fetchVoicestatus = 'failed';
        state.error = action.error.message;
      })
      .addCase(addVoiceSnippet.pending, (state) => {
        state.addVoicestatus = 'loading';
      })
      .addCase(addVoiceSnippet.fulfilled, (state, action) => {
        state.addVoicestatus = 'succeeded';
        // state.snippets = action.payload.allVoiceSnippets;
        state.snippets = action.payload;

      })
      .addCase(addVoiceSnippet.rejected, (state, action) => {
        state.addVoicestatus = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteVoiceSnippet.pending, (state) => {
        state.deleteVoicestatus = 'deleting';
      })
      .addCase(deleteVoiceSnippet.fulfilled, (state, action) => {
        state.deleteVoicestatus = 'succeeded';
        state.snippets = action.payload;
      })
      .addCase(deleteVoiceSnippet.rejected, (state, action) => {
        state.deleteVoicestatus = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteVoiceAndTextSnippets.pending, (state) => {
        state.deleteVoiceAndTextStatus = 'deleting';
      })
      .addCase(deleteVoiceAndTextSnippets.fulfilled, (state, action) => {
        state.deleteVoiceAndTextStatus = 'succeeded';
        state.snippets = action.payload.voiceDelResponse;
      })
      .addCase(deleteVoiceAndTextSnippets.rejected, (state, action) => {
        state.deleteVoiceAndTextStatus = 'failed';
        state.error = action.error.message;
      });
  },
});

export default voiceSnippetSlice.reducer;

// export const selectAllVoiceSnippets = (state) => {
//   let snippets = []
//   if (state.user.voiceSnippets.fetchVoicestatus === "succeeded" ||
//     state.user.voiceSnippets.addVoicestatus === "succeded") {
//     // console.log(' state.user.voiceSnippets', state.user.voiceSnippets)
//     try {
//       snippets = state.user.voiceSnippets.snippets.snippets
//     }
//     catch (e) {
//       console.log('no snippets', e.message)
//       snippets = []
//     }
//   }
//   else {
//     console.log('curstate voiceSnippets.fetchVoicestatus', state.user.voiceSnippets.fetchVoicestatus)

//   }
//   return snippets;
// }
export const selectVoiceSnippetsStatus = (state) => {
  if (state === undefined || state.user === undefined) return "idle";
  let snippetStatus = state.user.voiceSnippets.fetchVoicestatus;
  return snippetStatus;
}
